<template>
    <div>
        <h2 align="center">ตั้งค่าวันลา</h2>
        <br/>
        <div class="row form-group">
            <div class="col-sm-4 text-right">
                <label for="name_day">วันลา</label>
            </div>
            <div class="col-sm-6">
                <input id="name_day" class="form-control"
                       v-model="form.name"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-sm-4 text-right">
                <label>จำนวนวันลา</label>
            </div>
            <div class="col-sm-6">
                <input class="form-control"
                       v-model="form.number_of_leave"/>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-sm-4 text-right">
                <div class="form-group">
                    <label>พนักงานรายเดือน</label>
                </div>
            </div>
            <div class="col-sm-8">
                <div class="form-group form-inline">
                    <label for="month">อายุงานมากกว่า</label>
                    <input id="month" class="form-control col-sm-3"
                           v-model="form.how_long_month"
                           type="text"/>
                    <label for="month">เดือน</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 text-right">
                <div class="form-group">
                    <label>พนักงานรายวัน</label>
                </div>
            </div>
            <div class="col-sm-8">
                <div class="form-group form-inline">
                    <label for="day">อายุงานมากกว่า</label>
                    <input id="day" class="form-control col-sm-3"
                           v-model="form.how_long_day"
                           type="text"/>
                    <label for="day">เดือน</label>
                </div>
            </div>
        </div>
        <div class="col text-center">
            <button type="button" @click="saveLeaveingDay"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก</button>&nbsp&nbsp
            <button type="button" @click="cancelLeavingDay"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
        <!--<pre class="alert alert-danger">{{form}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "leave-day-modal",
        created(){

        },
        data(){
          return{

          }
        },
        computed:{
            ...mapState({
                form:state=>{
                    return state.LeaveDay.leaveDayForm
                },
                user:state=>{
                    return state.Auth.user;
                },
            })
        },
        methods:{
            saveLeaveingDay(){
                this.form.user_id = this.user.id;
                if(!this.form.name){
                    alert("กรุณาใส่รายการวันลา");
                }
                else{
                    if(this.form.how_long_month){
                        this.form.how_long_month = parseInt(this.form.how_long_month);
                    }
                    if(this.form.how_long_day){
                        this.form.how_long_day = parseInt(this.form.how_long_day);
                    }
                    this.$store.dispatch("LeaveDay/saveLeaveDay",{
                        id : this.form.id,
                        data : this.form
                    });
                    this.$emit("submit",this.form);
                }
            },
            cancelLeavingDay(){
                this.$emit("submit",0);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .margin {
        margin: 10px;
    }
    .padding{
        padding: 10px;
    }
</style>
